export default "__VITE_ASSET__Cno7u_TB__"